import { assertAllowedAnalyticsEvent } from "./analytics-taxonomy";
import { readStoredUtm, type UtmFields } from "./analytics-utm";

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

export function shouldSendGa4Pageview(
  prevPath: string | null,
  nextPath: string,
): boolean {
  if (!nextPath || prevPath === null || nextPath === prevPath) {
    return false;
  }
  return true;
}

export function buildGa4PageviewCommand(
  path: string,
  utm: UtmFields | null,
): {
  event: "page_view";
  params: Record<string, string>;
} {
  const params: Record<string, string> = { page_path: path };

  if (utm) {
    for (const [key, value] of Object.entries(utm)) {
      if (typeof value === "string" && value !== "") {
        params[key] = value;
      }
    }
  }

  assertAllowedAnalyticsEvent("page_view", params);

  return { event: "page_view", params };
}

export function reportGa4SpaPageview(
  pathname: string,
  prevPath: string | null,
): string | null {
  if (!shouldSendGa4Pageview(prevPath, pathname)) {
    return null;
  }

  const { params } = buildGa4PageviewCommand(pathname, readStoredUtm());

  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", "page_view", params);
    return pathname;
  }

  return null;
}
